/**
 *
 * Notes: May, 2019
 * Original source code pulled (and edited) from previous website.
 * Assuming this was custom developed by previous vendor since license was not provided.
 *
 */

import $ from 'jquery';

export default RetirementSavings;

//////////

function RetirementSavings (o) {

    let $container = $(o),
        $form = null,
        $income = null,
        $benefits = null,
        $pension = null,
        $incomeNeeded = null,
        $amount = null;

    $form = $container.find("form");
    $income = $form.find("input[name=income]");
    $benefits = $form.find("input[name=benefits]");
    $pension = $form.find("input[name=pension]");

    $incomeNeeded = $form.find("input[name=income-needed]");
    $amount = $form.find("input[name=amount]");

    $form.submit(function(e) {
        $form.find('.calc-results').removeClass('hidden');
        let a = Number($income.val().replace("$","")),
            b = Number($benefits.val().replace("$","")),
            c = Number($pension.val().replace("$",""));

        $incomeNeeded.val((a-b-c).toFixed(2));
        $amount.val(((a-b-c)*25).toFixed(2));
        $incomeNeeded.currency();
        $amount.currency();

        e.preventDefault();
        return false;

    });

    $container.find("button[type='reset']").on('click',function(){
        $('.calc-results').addClass('hidden');
        $income.focus();
        //e.preventDefault();
        //return false;
    });

}


// WEBPACK FOOTER //
// ./src/calculators/retirement-savings.js